/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ n: NonNullable<unknown>, name: NonNullable<unknown> }} Rounds_Seat_NInputs */



/**
* | output |
* | --- |
* | "Seat {n}: {name}" |
*
* @param {Rounds_Seat_NInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const rounds_seat_n = /** @type {((inputs: Rounds_Seat_NInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rounds_Seat_NInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Placement ${i?.n} : ${i?.name}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Asiento ${i?.n}: ${i?.name}`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`Assento ${i?.n}: ${i?.name}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Posto ${i?.n}: ${i?.name}`)
	return /** @type {LocalizedString} */ (`Seat ${i?.n}: ${i?.name}`)
});